import Element from "./element";

export class Tabs extends Element {
	constructor(props) {
		super(props);

		this.$activeTab = null;

		this.TAB_SWITCH_EVENT = 'tabSwitch';

		this.init();
	}

	init() {
		if (!this.$root || !this.$root.dataset || this.$root.dataset.tabs !== 'tab-list') {
			throw new Error('Tabs: Root element is not defined.');
		}

		this.$tabItems = this.$root.querySelectorAll('[data-tabs="tab"]');

		super.init();
		this.bootstrap();
	}

	bootstrap() {
		/* Find Active */
		const $activeTab = this.findActive();
		this.setActiveTab($activeTab);

		if (!this.$activeTab) {
			this.setActiveTab(this.$tabItems[0]);
		}
	}

	addEventListeners() {
		this.$tabItems.forEach(($tab) => {
			$tab.addEventListener('click', (e) => {
				this.setActiveTab($tab);
			});
		});
	}

	findActive() {
		return Array.from(this.$tabItems).find(($tab) => $tab.classList.contains('-active'));
	}

	setActiveTab($tab) {
		if (!$tab) {
			return;
		}

		if (this.$activeTab) {
			this.deactivateTab(this.$activeTab);
		}

		$tab.classList.add('-active');
		this.$activeTab = $tab;
		this.dispatchEvent(this.TAB_SWITCH_EVENT, $tab.dataset.id);
	}

	deactivateTab($tab) {
		$tab.classList.remove('-active');
	}

	getActiveTabId() {
		return this.$activeTab.dataset.id;
	}

	setActiveById(id) {
		const $tab = Array.from(this.$tabItems).find(($tab) => $tab.dataset.id == id);

		if ($tab) {
			this.setActiveTab($tab);
		}
	}
}

export class BlockTabs extends Element {
	constructor(props) {
		super(props);

		this.$currentActiveContent = null;
		this.tabsController = null;

		this.init();
	}

	init() {
		if (!this.$root || !this.$root.dataset || this.$root.dataset.tabs !== 'root') {
			throw new Error('Block Tabs: Root element is not defined.');
		}

		this.$contentList = this.$root.querySelectorAll('[data-tabs="content"]');

		this.$currentActiveContent = Array.from(this.$contentList).find(($content) => $content.classList.contains('-active'));

		if (!this.$currentActiveContent) {
			this.$currentActiveContent = this.$contentList[0];
		}

		this.initTabsController();

		super.init();
	}

	initTabsController() {
		this.tabsController = new Tabs({ $root: this.$root.querySelector('[data-tabs="tab-list"]') });
	}

	addEventListeners() {
		this.tabsController.subscribe('tabSwitch', ({ detail }) => {
			this.setActiveContent(detail);
		});
	}

	setActiveContent(id) {
		if (this.$currentActiveContent) {
			this.$currentActiveContent.classList.remove('-active');
		}

		const $newActive = Array.from(this.$contentList).find(($content) => ($content.dataset.for === id));

		if ($newActive) {
			$newActive.classList.add('-active');
			this.$currentActiveContent = $newActive;
		}
	}
}